import { FeedbackUnpromptedDraft } from '@app/models/feedback/feedback.model';

export const mockFeedbackUnpromptedDrafts: FeedbackUnpromptedDraft[] = [

];